export default __webpack_public_path__ + "static/media/card.31da1669.png";